import { useTranslation } from '@wix/yoshi-flow-editor';
import type { FC } from 'react';
import React, { Fragment } from 'react';

import { useWidget } from '../../../../../../../contexts/widgets';
import styles from './Title.scss';

export const Title: FC = () => {
  const { t } = useTranslation();
  const { member, computed } = useWidget();

  const { isDesignPreview, isDisplayPreview } = computed;
  const title = member.title;
  const shouldShowTitlePreview =
    (isDesignPreview || isDisplayPreview) && !title;

  return (
    <>
      {title && (
        <div className={styles.container}>
          <p className={styles.title}>{title}</p>
        </div>
      )}
      {shouldShowTitlePreview && (
        <div className={styles.container}>
          <p className={styles.title}>{t('design-tab.title-preview')}</p>
        </div>
      )}
    </>
  );
};
